import { render } from "./fundflowlog.vue?vue&type=template&id=2d8290e9"
import script from "./fundflowlog.vue?vue&type=script&lang=js"
export * from "./fundflowlog.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Kaung\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__